import { render, staticRenderFns } from "./productsSliderItem.vue?vue&type=template&id=38272741&scoped=true"
import script from "./productsSliderItem.vue?vue&type=script&lang=js"
export * from "./productsSliderItem.vue?vue&type=script&lang=js"
import style0 from "./productsSliderItem.vue?vue&type=style&index=0&id=38272741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38272741",
  null
  
)

export default component.exports